import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { MastersuiteService } from '../mastersuite.service';
import { AuthenticationService } from '@app/_services';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EnvironmentMapModalComponent } from '@app/_shared/environment-map-modal/environment-map-modal.component';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.less']
})
export class DetailsComponent implements OnInit {
  mastersuiteDetails: any = {};
  mastersuiteParDetails: any;
  testSuiteList: any;
  testcaseList: any;
  activeId;
  activeEnv;

  constructor(private route: ActivatedRoute, public mastersuiteservice: MastersuiteService, private AuthService: AuthenticationService, private modalService: NgbModal, private titleService: Title) { }

  ngOnInit() {
    this.route.params.subscribe(() => {
      this.mastersuiteDetails = this.route.snapshot.data['details'].response;
      this.AuthService.getUserRoleByProject(this.mastersuiteDetails['role']); /* Role */
      this.titleService.setTitle('MS | ' + this.mastersuiteDetails.name);

      this.getMastersuiteEnv(this.mastersuiteDetails['project']['id']);
      this.mastersuiteservice.getMasterSuiteDetails(this.mastersuiteDetails['id']).subscribe((data: any) => {
        this.mastersuiteParDetails = data.response;
      });
      this.mastersuiteservice.getMasterSuiteTestSuites(this.mastersuiteDetails['id']).subscribe((data: any) => {
        this.testSuiteList = data.response;
        if (data.response !== null) {
          this.activeId = data.response[0].testSuiteId;
          this.mastersuiteservice.getTestcasesByTestSuiteId(data.response[0].testSuiteId).subscribe((testcaseList: any) => {
            this.testcaseList = testcaseList.response;
          });
        }
      });
    });
  }

  getTestcasesByTestSuiteId(id) {
    this.mastersuiteservice.getTestcasesByTestSuiteId(id).subscribe((testcaseList: any) => {
      this.testcaseList = testcaseList.response;
      this.activeId = id;
    });
  }

  getMastersuiteEnv(id) {
    this.mastersuiteservice.getEnv(id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.activeEnv = data.response;
      }
    });
  }

  showEnvMapperDetails() {
    const modalRef = this.modalService.open(EnvironmentMapModalComponent,
      {
        ariaLabelledBy: 'modal-basic-title',
        backdrop: true,
        centered: true,
        size: 'lg'
      });

    modalRef.componentInstance.environments = this.activeEnv;
    modalRef.componentInstance.testsuiteDetails = this.mastersuiteDetails;
  }
}
